import { render, staticRenderFns } from "./BoxReason.vue?vue&type=template&id=a17e6fa0&scoped=true&"
import script from "./BoxReason.vue?vue&type=script&lang=js&"
export * from "./BoxReason.vue?vue&type=script&lang=js&"
import style0 from "./BoxReason.vue?vue&type=style&index=0&id=a17e6fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17e6fa0",
  null
  
)

export default component.exports